import { useT } from "../i18n/index.js";

export function LoadingSpinner({ label }: { label?: string }) {
  const t = useT();
  // One resolved string for both: the visible text used the raw prop, so a
  // spinner without an explicit label showed nothing at all.
  const text = label ?? t("common.loadingEllipsis");
  return (
    <div
      role="status"
      aria-label={text}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        padding: "4rem",
        color: "var(--text-dim)",
        fontSize: "var(--text-sm)",
      }}
    >
      <style>{`
        @keyframes spin-ring {
          to { transform: rotate(360deg); }
        }
        .loading-ring {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 3px solid var(--border);
          border-top-color: var(--brand);
          animation: spin-ring 0.75s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .loading-ring { animation: none; border-top-color: var(--brand); }
        }
      `}</style>
      <div className="loading-ring" aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
}
